import { useEffect } from "react";
import { cn } from "@/lib/utils";

type Level = "base" | "over";

const Z: Record<Level, { backdrop: string; panel: string }> = {
	base: { backdrop: "z-40", panel: "z-50" },
	over: { backdrop: "z-[60]", panel: "z-[70]" },
};

export function DrawerShell({
	open,
	onClose,
	children,
	level = "base",
	escEnabled = true,
}: {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	level?: Level;
	escEnabled?: boolean;
}) {
	useEffect(() => {
		if (!open || !escEnabled) return;
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [open, escEnabled, onClose]);

	const z = Z[level];

	return (
		<>
			<div
				className={cn(
					"fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity",
					z.backdrop,
					open ? "opacity-100" : "pointer-events-none opacity-0",
				)}
				onClick={onClose}
			/>
			<aside
				className={cn(
					"fixed right-0 top-0 flex h-full w-full max-w-4xl flex-col bg-surface shadow-2xl transition-transform duration-300",
					z.panel,
					open ? "translate-x-0" : "translate-x-full",
				)}
				aria-hidden={!open}
			>
				{children}
			</aside>
		</>
	);
}
